import axios from "axios";
import { toast } from 'react-toastify';

interface PropData {
  action: string;
  body?: any;
  isFormData?: boolean;
  isShowError?: boolean;
  id?: string;
  type?: string;
  file?: any;
  key?: any;
}

const WebService = {
  getAccesstoken: function (props: PropData) {
    this.addLoader(props?.id);
    let url = this.getBaseUrl(props.type)
    return new Promise((resolve, reject) => {
      var bodyFormData = new URLSearchParams();
      for (let key in props.body) {
        bodyFormData.append(key, props.body[key]);
      }
      const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
      };
      axios
        .post(`${url}${props.action}`, bodyFormData, {
          headers: headers,
        })
        .then((response) => {
          if (typeof window !== 'undefined') {
            localStorage.setItem("token", response.data.token);
          }
          resolve(response.data);
          this.removeLoader(props?.id);
        })
        .catch((error) => {
          this.removeLoader(props?.id);
          reject(this.errorHandler(error));
        });
    });
  },

  postAPI: function <T>(props: PropData) {
    this.addLoader(props?.id);
    let url = this.getBaseUrl(props.type)
    return new Promise<T>((resolve, reject) => {
      var bodyFormData = new URLSearchParams();
      for (let key in props.body) {
        bodyFormData.append(key, props.body[key]);
      }
      if(props?.action == 'customer/verify'){
        localStorage.removeItem("token");
      }
      axios
        .post(
          `${url}${props.action}`,
          props.isFormData ? bodyFormData : props.body,
          {
            headers: this.getHeaders(),
          }
        )
        .then((response) => {
          resolve(response.data);
          this.removeLoader(props?.id);
        })
        .catch((error) => {
          if (error && error.response && error.response.status == 401) {
            this.clearLocalStorage()
            window.location.href = "/";
          }
          this.removeLoader(props?.id);
          reject(this.errorHandler(error, props.isShowError));
        });
    });
  },

  putAPI: function (props: PropData) {
    this.addLoader(props?.id);
    let url = this.getBaseUrl(props.type)
    return new Promise((resolve, reject) => {
      var bodyFormData = new URLSearchParams();
      for (let key in props.body) {
        bodyFormData.append(key, props.body[key]);
      }
      axios
        .put(`${url}${props.action}`, props.body, {
          headers: this.getHeaders(),
        })
        .then((response) => {
          resolve(response.data);
          this.removeLoader(props?.id);
        })
        .catch((error) => {
          if (error && error.response && error.response.status == 401) {
            this.clearLocalStorage()
            window.location.href = "/";
          }
          this.removeLoader(props?.id);
          reject(this.errorHandler(error));
        });
    });
  },

  getAPI: function <T>(props: PropData) {
    let params = new URLSearchParams();
    for (let key in props.body) {
      params.set(key, props.body[key]);
    }
    this.addLoader(props?.id);
    let url = this.getBaseUrl(props.type);
    return new Promise<T>((resolve, reject) => {
      axios
        .get(`${url}${props.action}`, {
          params: params,
          headers: this.getHeaders(),
        })
        .then((response) => {
          resolve(response.data);
          this.removeLoader(props?.id);
        })
        .catch((error) => {
          if (error && error.response && error.response.status == 401) {
            this.clearLocalStorage();
            window.location.href = "/";
          }
          this.removeLoader(props?.id);
          reject(this.errorHandler(error));
        });
    });
  },

  getValidationAPI: function <T>(props: PropData) {
    let params = new URLSearchParams();
    for (let key in props.body) {
      params.set(key, props.body[key]);
    }
    this.addLoader(props?.id);
    let url = this.getBaseUrl(props.type);
    return new Promise<T>((resolve, reject) => {
      axios
        .get(`${url}${props.action}`, {
          params: params,
          headers: this.getHeaders(),
        })
        .then((response) => {
          resolve(response.data);
          this.removeLoader(props?.id);
        })
        .catch((error) => {
          if (error && error.response && error.response.status == 401) {
            this.clearLocalStorage();
            window.location.href = "/";
          }
          this.removeLoader(props?.id);
          reject(error);
        });
    });
  },

  deleteAPI: function (props: PropData) {
    this.addLoader(props?.id)
    let url = this.getBaseUrl(props.type)
    return new Promise((resolve, reject) => {
      axios
        .delete(`${url}${props.action}`, {
          headers: this.getHeaders(),
        })
        .then((response) => {
          resolve(response.data);
          this.removeLoader(props?.id)
        })
        .catch((error) => {
          if (error && error.response && error.response.status == 401) {
            this.clearLocalStorage()
            window.location.href = "/";
          }
          this.removeLoader(props?.id)
          reject(this.errorHandler(error));
        });
    });
  },

  fileUploadAPI: function (props: PropData) {
    var formData = new FormData();
    if (!props.key) {
      props.key = "file";
    }
    formData.append(props.key, props.file);
    for (let key in props.body) {
      formData.append(key, props.body[key]);
    }
    this.addLoader(props?.id);
    let url = this.getBaseUrl();
    return new Promise((resolve, reject) => {
      axios
        .post(`${url}${props.action}`, formData, {
          headers: this.getMultipartHeaders(),
        })
        .then((response) => {
          resolve(response.data);
          this.removeLoader(props?.id);
        })
        .catch((error) => {
          // props.isShowError ? reject(this.errorHandler(error)) : reject(error);
          reject(this.errorHandler(error));
          this.removeLoader(props?.id);
        });
    });
  },

  getHeaders: function () {
    if (typeof window !== 'undefined') {
      if (localStorage.getItem("token") == null) {
        return {
          "Content-Type": "application/json"
        };
      }

      return {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("token")
      }
    }
  },

  getMultipartHeaders: function () {
    if (typeof window !== 'undefined') {
      return {
        "Authorization": "Bearer " + localStorage.getItem("token")
      };
    }
  },

  errorHandler: function (error: any, showErrorOnPopup?: boolean) {
    if (error?.response) {
      error = error.response;
    }
    var errorMessage;
    if (!error || !error.status) {
      errorMessage = "Server Not Responding";
    } else if (error.status === 401) {
      this.clearLocalStorage()
      window.location.href = "/";
    } else if (error.status === 400) {
      // alert(error?.data?.message)
      errorMessage = errorMessage = (error && error?.data && error?.data?.errors && error?.data?.errors[0]) || (error && error?.data && error?.data?.Validation && error?.data?.Validation?.message ) || (error && error?.data?.message) ||  "Invalid Request Body";
    } else if (error.status === 500) {
      errorMessage =
        (error &&
          error.data &&
          error.data.ErrorDetails &&
          error.data.ErrorDetails.message) ||
        "An unkown exception has occured. Please contact to administrator";
    } else {
      errorMessage = error.data.message;

    }
    if (!showErrorOnPopup) {
      toast.error(errorMessage, { theme: "colored" });
    }
    return errorMessage;
  },

  addLoader(id: any) {
    if (id) {
      var button = document.getElementById(id) as HTMLButtonElement | null;
      if (button != null) {
        button.disabled = true;
        var loader = document.createElement("img");
        loader.src = "/images/loading.gif";
        loader.className = "button-loader";
        button.prepend(loader);
      }
    }
  },

  removeLoader(id: any) {
    if (id) {
      var button = document.getElementById(id) as HTMLButtonElement | null;
      if (button != null) {
        button.disabled = false;
        button.removeChild(button.childNodes[0]);
      }
    }
  },

  // Session keys only. This runs on every 401, including a token that expired
  // while the customer's car is physically charging.
  //
  // 24/09/2026: an earlier version of this also cleared dataHex. That looked
  // like the right privacy fix and was in fact a worse bug: dataHex carries
  // uuId7/uuId8 (booking and transaction id), the site has no my-bookings screen
  // to recover them, and a customer whose token expired mid-session was left
  // unable to stop or settle a charge that was still running. The booking now
  // survives a 401; only the identity goes.
  clearLocalStorage() {
    if (typeof window !== 'undefined') {
      localStorage.removeItem("token")
      localStorage.removeItem('loginUserImage')
      localStorage.removeItem('uuid')
      localStorage.removeItem('type')
      localStorage.removeItem('customer_Id')
      localStorage.removeItem('is_guest')
    }
  },

  // End of the journey: the session is over and the booking is finished, so the
  // customer's details must not sit in a shared phone or a station kiosk for the
  // next person. Called from the screens that end a booking - NOT from the 401
  // handler, for the reason above.
  // 24/09/2026, CORRECTED same day: this called clearLocalStorage() and so threw
  // away the TOKEN too. Leaving Booking_Complete by its own "book again" link
  // then destroyed a live session mid-SPA, and ensureGuestSession only runs on
  // App mount, so every later call 401'd and bounced the customer to "/". The
  // journey data goes; the session stays, because the customer is still the same
  // person and may well book again.
  //
  // Coverage caveat, deliberately accepted: this runs when Booking_Complete
  // unmounts, so a customer who closes the tab instead leaves dataHex behind.
  // Clearing on unload is NOT safe - the charging screen legitimately reloads
  // mid-session and needs dataHex to find its own booking - so the trade is to
  // keep a live session recoverable and accept that a truly abandoned tab keeps
  // its data until the next booking overwrites it.
  clearCustomerJourney() {
    if (typeof window !== 'undefined') {
      localStorage.removeItem('dataHex')
      localStorage.removeItem('charge_status')
      Object.keys(localStorage)
        .filter((k) => k.indexOf('slot_') === 0)
        .forEach((k) => localStorage.removeItem(k))
    }
  },

  getBaseUrl(type?: string) {
    return "https://api.energibharat.com/";
    // return "http://localhost:3000/"; // LOCAL TESTING - restore the live URL before deploying
    // return "http://ec2-13-202-37-64.ap-south-1.compute.amazonaws.com:3000/"
    // return "http://localhost:3000/";
  },

  
  
};


export default WebService;
